import React, {useState, useEffect} from "react";
import Layout from "../BlogParts/Layout";
import * as d3 from 'd3';
import seedrandom from "seedrandom";


import BlindMap from "./BlindMap";
import NameBox from "./NameBox";
import ReactTooltip from "react-tooltip";
import Tooltips from "./Tooltips";

const mapConversor = d => {
    d.x = +d.x;
    d.y = +d.y;
    return d;
}

const pointsConversor = d => {
    d.x = +d.x;
    d.y = +d.y;
    d.selected = false;
    return d;
}

const BlindMapApp = () => {
    seedrandom();
    const [mapData, setMapData] = useState([])
    const [blindPoints, setBlindPoints] = useState([])
    const [mapType, changeMapType] = useState("FullyVisible");
    const [nameBoxState, setNameBoxState] = useState("");
    const [clickHappened, setClickHappened] = useState(false)
    const [selectedPoint, selectPoint] = useState([])
    const [nameBoxColor, setNameBoxColor] = useState("gray")

    const reset = () => {
        setNameBoxState("")
        setClickHappened(false)
        selectPoint([])
        setNameBoxColor("gray")
    }

    useEffect(() => {
        d3.csv("/msc/csv/CZ20.csv", mapConversor).then(data => {
            setMapData(data);
        });
    }, []);

    useEffect(() => {
        d3.csv("/msc/csv/BlindPoints.csv", pointsConversor).then(data => {
            setBlindPoints(data);
        });
    }, []);

    const x1Accessor = d => d.x;
    const y1Accessor = d => d.y;

    const generatePoint = () => {
        ReactTooltip.rebuild()
        const selectedNumber = Math.floor(Math.random() * blindPoints.length)
        blindPoints.forEach((point, i) => {
                if (i === selectedNumber) {
                    point.x = +point.x;
                    point.y = +point.y;
                    point.selected = true;
                    selectPoint(point.name)
                    if (mapType === "GuessPoints") {
                        setNameBoxState(point.name)
                    }
                } else {
                    point.x = +point.x;
                    point.y = +point.y;
                    point.selected = false;
                }
            }
        )
        setBlindPoints(blindPoints)
        setClickHappened(false)
        setNameBoxColor("gray")

    }
    return (
        <div>
            <Tooltips
                data={blindPoints}
                mapType={mapType}
            />
            <BlindMap
                data = {[mapData, blindPoints]}
                xAccessors = {[x1Accessor]}
                yAccessors = {[y1Accessor]}
                markers = {["triangle"]}
                colors = {["o", "b"]}
                xLabel={"X-Label"}
                yLabel={"Y-Label"}
                selectedPoint={selectedPoint}
                clickState={clickHappened}
                onClick={setClickHappened}
                mapType={mapType}
            />
            <button onClick={() => {
                switch (mapType) {
                    case "FullyVisible":
                        changeMapType("GuessNames")
                        reset();
                        break;
                    case "GuessNames":
                        changeMapType("GuessPoints")
                        reset();
                        break;
                    case "GuessPoints":
                        changeMapType("FullyVisible")
                        reset();
                }
            }}>{mapType}</button>
            <button onClick={() => {
                if (mapType !== "FullyVisible") {
                    generatePoint()
                }
            }}>Generate</button>
            <NameBox
                value={nameBoxState}
                color={nameBoxColor}
                selectedPoint={selectedPoint}
                setName={setNameBoxState}
                setColor={setNameBoxColor}
                mapType={mapType}
            />
        </div>
    )
}

export default BlindMapApp